import { Box, Stack, Tooltip } from '@mui/material';
import { MessageIcon } from '@synergy/theme';
import { ReactElement, ReactNode } from 'react';
import { ReceiptAlert, getReceiptAlertColorCode } from '@synergy/models';

/**
 * A document's number as every list shows it: with the speech bubble of its
 * notice beside it, coloured by kind, the text on hover. Each list carried its
 * own copy and the cockpit and the order list none, so the notice was only
 * found by opening the document (#2184, #2326 R-244).
 */
export const PaloDocumentNumberCell = ({
    number,
    alert,
}: {
    number: ReactNode;
    alert?: ReceiptAlert | null;
}): ReactElement => (
    <Stack direction="row" alignItems="center" gap={1}>
        <Box>{number}</Box>
        {alert && (
            <Tooltip placement="top-start" title={<Box sx={{ textAlign: 'center' }}>{alert.text}</Box>}>
                <Stack direction="row" alignItems="center">
                    <MessageIcon color={getReceiptAlertColorCode(alert.type)} sx={{ fontSize: 18 }} />
                </Stack>
            </Tooltip>
        )}
    </Stack>
);
